import { render, staticRenderFns } from "./LandlordPropertyDetails.vue?vue&type=template&id=10d4e426&scoped=true"
import script from "./LandlordPropertyDetails.vue?vue&type=script&lang=js"
export * from "./LandlordPropertyDetails.vue?vue&type=script&lang=js"
import style0 from "./LandlordPropertyDetails.vue?vue&type=style&index=0&id=10d4e426&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d4e426",
  null
  
)

export default component.exports